module.exports = __webpack_public_path__ + "img/mail.c37d9d20.jpg";